import React from 'react';
import useAuthStore from '../store/useAuthStore';

const Navbar = () => {
  const {firstName, lastName} = useAuthStore((state) => state.user);

  return (
    <div className="py-6 px-8 border-b border-b-gray">
      <div className="flex items-center justify-between">
        <div className="font-medium">Welcome Back, {firstName}</div>
        <div className="flex items-center gap-5">
          {/* <BsSearch size={20} />
          <BsBell size={20} /> */}
          <div>
            {firstName} {lastName}
          </div>
          {/* <IoMdArrowDropdown size={30} /> */}
        </div>
      </div>
    </div>
  );
};

export default Navbar;
